import moment from "moment";
import { dateFormat } from "../constants/dateFormat";

export default class DateService {

    // UTC to local date with date and time
    static utcToLocalDate(date, format=null) {
        if (date) {
            let newDate = moment(date).local().format(format ? format :dateFormat.DATE_FORMAT_1);
            return newDate;
        } else {
            // return 'N/A';
            return '';
        }
    }

    // UTC to local date with date only
    static utcToLocalDateOnly(date, format=null) {
        if (date) {
            let newDate = moment(date).local().format(format ? format :dateFormat.DATE_FORMAT_2);
            return newDate;
        } else {
            return '';
        }
    }

    // UTC to local date with time only
    static utcToLocalTimeOnly(date, format=null) {
        if (date) {
            let newDate = moment(date).local().format(format ? format :dateFormat.TIME_FORMAT_1);
            return newDate;
        } else {
            return '';
        }
    }

    // Local date with date only
    static localDateOnly(date, format=null) {
        if (date) {
            let newDate = moment(date).format(format ? format :dateFormat.DATE_FORMAT_2);
            return newDate;
        } else {
            return '';
        }
    }
}